import { useState } from 'react'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'

export default function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')
  const [showModal, setShowModal] = useState(false)

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    // Aqui você chamaria uma API para lidar com a recuperação de senha
    setMessage(`Recovery email sent to ${email}`)
    setShowModal(true) // Mostrar o modal após a submissão
    setEmail('')
  }

  const closeModal = () => {
    setShowModal(false)
    setMessage('')
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="w-full max-w-md p-8 space-y-8 rounded-lg shadow-xl bg-input text-foreground-color">
        <div className="text-center">
          <h2 className="mt-6 text-3xl font-extrabold text-primary">Recuperar Senha</h2>
          <p className="mt-2 text-sm text--secondary">Digite seu email para receber as instruções de recuperação</p>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div>
            <Input
              id="email"
              name="email"
              type="email"
              autoComplete="email"
              required
              className="appearance-none rounded-md block w-full px-3 py-2 bg-input text-foreground border border-border-color focus:outline-none focus:border-primary"
              placeholder="Endereço de email"
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
          </div>
          <div>
            <Button
              type="submit"
              className="w-full flex justify-center py-2 px-4 rounded-md text-sm font-medium bg-primary text-white hover:bg-primary-hover focus:outline-none"
            >
              Enviar Email de Recuperação
            </Button>
          </div>
        </form>
      </div>

      {/* Popup Modal */}
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg p-6 space-y-4 shadow-lg">
            <h3 className="text-lg font-medium text-gray-900">Sucesso!</h3>
            <p>{message}</p>
            <Button
              onClick={closeModal}
              className="mt-4 w-full flex justify-center py-2 px-4 rounded-md text-sm font-medium bg-primary text-white hover:bg-primary-hover focus:outline-none"
            >
              Fechar
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}
